module.exports = __webpack_public_path__ + "img/store-map.990b4a49.png";